module.exports = __webpack_public_path__ + "img/reportSecondary.4f812ce4.png";